import { pgpEncrypt } from '@axa-asia/hk-emma-web-module/lib/openpgp/openpgp-utils';
import { goTo } from '../../actions/routing';
import config from '../../config';
import { muleSoftFetch } from '../../utils/fetch';
import { parseQueryString } from '../../utils/queryString';
import { getAxaIdByJwtToken } from '../../utils/common-functions';
import { getErrorConfig } from '../../utils/error-code';
import {
  ROUTE_NAMES,
  POLICY_TYPE_CODES,
  FEATURE_CODES,
} from '../../constants/constants';
import {
  formatContactsToArray,
  getShouldShowUsernameField,
} from '../../utils/helpers';
import { mapFeToApiField } from './emma-retrieveAccount';

const INITIAL = 'INITIAL'; // Deprecated should call emma-retrieveAccount one
const EM_FINDMYPOLICY_SERVER_REQ_START = 'EM_FINDMYPOLICY_SERVER_REQ_START'; // Deprecated should call emma-retrieveAccount one
const EM_FINDMYPOLICY_SERVER_REQ_COMPLETE = // Deprecated should call emma-retrieveAccount one
  'EM_FINDMYPOLICY_SERVER_REQ_COMPLETE';
const EM_FINDMYPOLICY_SUCCESS = 'EM_FINDMYPOLICY_SUCCESS';
const EM_FINDMYPOLICY_VERIFY = 'EM_FINDMYPOLICY_VERIFY';
const EM_FINDMYPOLICY_NOT_MATCH = 'EM_FINDMYPOLICY_NOT_MATCH';
const EM_FINDMYPOLICY_FAIL = 'EM_FINDMYPOLICY_FAIL';
const EM_FINDPOLICY_CARDTYPE_SEL = 'EM_FINDPOLICY_CARDTYPE_SEL';
const EM_FINDPOLICY_POLICYTYPE_SEL = 'EM_FINDPOLICY_POLICYTYPE_SEL';

const EM_FINDMYPOLICY_AGREEMENTS_STATUS_FETCH_START =
  'EM_FINDMYPOLICY_AGREEMENTS_STATUS_FETCH_START';

const EM_FINDMYPOLICY_AGREEMENTS_STATUS_FETCH_COMPLETE =
  'EM_FINDMYPOLICY_AGREEMENTS_STATUS_FETCH_COMPLETE';

const EM_FINDMYPOLICY_AGREEMENTS_STATUS_FETCH_FAIL =
  'EM_FINDMYPOLICY_AGREEMENTS_STATUS_FETCH_FAIL';

const initialState = {
  policyType: '',
  cardType: '',
  isSubmitting: false,
  isLoading: false,
  agreementsStatus: {},
  isFindMyPolicySuccess: false,
  errorCode: '',
  checkHash: '',
  contactInfo: '',
  contactType: '',
  email: '',
  mobile: '',
  countryCode: '',
  submitValues: {},
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case INITIAL:
      return {
        ...state,
        isSubmitting: false,
      };
    case EM_FINDMYPOLICY_SERVER_REQ_START:
      return {
        ...state,
        isSubmitting: true,
      };
    case EM_FINDMYPOLICY_SERVER_REQ_COMPLETE:
      return {
        ...state,
        isSubmitting: false,
      };
    case EM_FINDMYPOLICY_SUCCESS:
      return {
        ...state,
        isFindMyPolicySuccess: true,
        errorCode: action.errorCode,
      };
    case EM_FINDMYPOLICY_VERIFY:
      return {
        ...state,
        contactInfo: action.contactInfo,
        contactType: action.contactType,
        countryCode: action.countryCode,
      };
    case EM_FINDMYPOLICY_NOT_MATCH:
      return {
        ...state,
        checkHash: action.checkHash,
        userNames: action.userNames,
        countryCodeMap: action.countryCodeMap,
        emailMap: action.emailMap,
      };
    case EM_FINDMYPOLICY_FAIL:
      return {
        ...state,
        isFindMyPolicySuccess: false,
        errorCode: action.errorCode,
        errorValues: action.errorValues,
        errorData: action.errorData,
      };
    case EM_FINDPOLICY_CARDTYPE_SEL:
      return {
        ...state,
        cardType: action.cardType,
      };
    case EM_FINDPOLICY_POLICYTYPE_SEL:
      return {
        ...state,
        policyType: action.policyType,
      };
    case EM_FINDMYPOLICY_AGREEMENTS_STATUS_FETCH_START:
      return {
        ...state,
        isLoading: true,
      };
    case EM_FINDMYPOLICY_AGREEMENTS_STATUS_FETCH_COMPLETE:
      return {
        ...state,
        isLoading: false,
        agreementsStatus: action.payload.agreementsStatus,
      };
    case EM_FINDMYPOLICY_AGREEMENTS_STATUS_FETCH_FAIL:
      return {
        ...state,
        agreementsStatus: {},
        isLoading: false,
      };
    default:
      return state;
  }
}

export const initial = () => {
  // Deprecated should call emma-retrieveAccount one
  return {
    type: INITIAL,
  };
};

export const redirectOnPolicyTypeSel = (policyType) => {
  return (dispatch, getState) => {
    const currLang = getState().language.lang;
    dispatch({
      type: EM_FINDPOLICY_POLICYTYPE_SEL,
      policyType,
    });

    const routeName = ROUTE_NAMES[policyType];

    if (routeName) {
      dispatch(
        goTo(
          `/${currLang}/${config.webview.identityFEPath}/emma/find-my-policy/${routeName}`,
        ),
      );
    }
  };
};

export const redirectOnCardSelection = (cardType, policyType) => {
  return (dispatch, getState) => {
    const currLang = getState().language.lang;
    dispatch({
      type: EM_FINDPOLICY_CARDTYPE_SEL,
      cardType,
    });

    const routeName = ROUTE_NAMES[policyType];

    if (cardType === 'axa') {
      dispatch(
        goTo(
          `/${currLang}/${config.webview.identityFEPath}/emma/find-my-policy/${routeName}/axa-card-selected`,
        ),
      );
    } else if (cardType === 'other') {
      dispatch(
        goTo(
          `/${currLang}/${config.webview.identityFEPath}/emma/find-my-policy/${routeName}/other-card-selected`,
        ),
      );
    } else if (cardType === 'hkId') {
      dispatch(
        goTo(
          `/${currLang}/${config.webview.identityFEPath}/emma/find-my-policy/${routeName}/hkid-selected`,
        ),
      );
    } else if (cardType === 'passport') {
      dispatch(
        goTo(
          `/${currLang}/${config.webview.identityFEPath}/emma/find-my-policy/${routeName}/passport-selected`,
        ),
      );
    }
  };
};

export const emmaSubmitFindPolicyGenOTP = (submitValues, fromPage = '') => {
  return async (dispatch, getState) => {
    const currLang = getState().language.lang;
    const routeName = ROUTE_NAMES[submitValues.policyType] || '';

    let formData;
    if (submitValues.shouldShowUsernameField) {
      formData = {
        checkHash: submitValues.checkHash,
        documentID: submitValues.documentID
          ? submitValues.documentID.trim()
          : submitValues.documentID,
        documentType: submitValues.documentType,
        dateOfBirth: submitValues.dateOfBirth,
        loginId: submitValues.loginId,
        locale: currLang,
        axaId: getAxaIdByJwtToken(),
      };
    } else {
      formData = {
        checkHash: submitValues.checkHash,
        contactType: submitValues.contactType,
        contactIndex: String(submitValues.contactIndex),
        locale: currLang,
        axaId: getAxaIdByJwtToken(),
        ...(submitValues.PIPL ? { PIPL: submitValues.PIPL } : {}),
      };
    }

    dispatch({
      type: EM_FINDMYPOLICY_VERIFY,
      contactInfo: submitValues.selectedLabel,
      contactType: submitValues.contactType,
      countryCode: submitValues.countryCode,
    });

    dispatch({
      type: EM_FINDMYPOLICY_SERVER_REQ_START,
    });

    const featureName =
      submitValues.policyType === 'pnc' ? 'findmypolicyPNC' : 'findmypolicy';
    const queryStr = {
      featureName,
    };
    const option = {
      headers: {
        apikey: config.muleApiKey,
      },
    };
    await muleSoftFetch(
      parseQueryString(
        `${config.webview.muleApiBaseUrl}/customers/registration`,
        queryStr,
      ),
      'post',
      { registrationRequest: formData },
      option,
    )
      .then(() => {
        if (submitValues.autoLink) {
          dispatch({
            type: EM_FINDMYPOLICY_SUCCESS,
          });
          dispatch(
            goTo(
              `/${currLang}/${config.webview.identityFEPath}/emma/find-my-policy/${routeName}/policy-found`,
            ),
          );
        } else {
          dispatch({
            type: EM_FINDMYPOLICY_SERVER_REQ_COMPLETE,
          });
          dispatch(
            goTo(
              `/${currLang}/${config.webview.identityFEPath}/emma/find-my-policy/${routeName}/policy-verify`,
            ),
          );
        }
      })
      .catch((error) => {
        dispatch({
          type: EM_FINDMYPOLICY_SERVER_REQ_COMPLETE,
        });

        let errorCode;
        if (error.response && error.response.data.response.reasonCode) {
          errorCode = error.response.data.response.reasonCode;
          dispatch({
            type: EM_FINDMYPOLICY_FAIL,
            errorCode,
          });
        } else {
          errorCode = 'CUSEXP';
          dispatch({
            type: EM_FINDMYPOLICY_FAIL,
            errorCode,
          });
        }

        const errorConfig = getErrorConfig({
          apiCode: errorCode,
          featureCode: FEATURE_CODES.forgetUsername,
          policyTypeCode: POLICY_TYPE_CODES[submitValues.policyType],
        });

        dispatch(
          goTo(
            `/${currLang}/${
              config.webview.identityFEPath
            }/emma/find-my-policy/${routeName}/policyfound-fail?errorCode=${
              errorConfig.errorCode
            }&fromPage=${encodeURIComponent(fromPage)}`,
          ),
        );
      });
  };
};

export const emmaSubmitFindPolicyByHKID = (submitValues, fromPage = '') => {
  return async (dispatch, getState) => {
    const currStateVal = getState();
    const currLang = currStateVal.language.lang;
    // const fmpObj = currStateVal.emmaFindMyPolicy;

    const body = mapFeToApiField(submitValues);

    const toBeEncryptedRequest = {
      ...body,
    };
    const routeName = ROUTE_NAMES[body.policyType] || '';

    const encryptedRequest = await pgpEncrypt(
      JSON.stringify(toBeEncryptedRequest),
      config.apiEncryptPublicKey,
    );

    const option = {
      headers: {
        apikey: config.muleApiKey,
      },
    };

    const formData = {
      searchObject: encryptedRequest,
      captchaToken: submitValues.captchaToken,
    };

    dispatch({
      type: EM_FINDMYPOLICY_SERVER_REQ_START,
    });
    await (config.isMockResponse
      ? Promise.resolve((await import('./mocks/findMyPolicy')).default)
      : muleSoftFetch(
          `${config.webview.muleApiBaseUrl}/customers/search`,
          'post',
          { searchRequest: formData },
          option,
        )
    )
      .then(async (data) => {
        dispatch({
          type: EM_FINDMYPOLICY_SERVER_REQ_COMPLETE,
        });
        if (data.data) {
          // if cwp loginId equals to contact from input policy, call link api directly
          const isMobileUsed = data.data.isMobileUsed.map((item, index) => {
            return {
              ...item,
              index,
            };
          });
          const isEmailUsed = data.data.isEmailUsed.map((item, index) => {
            return {
              ...item,
              index,
            };
          });

          const { emails, mobiles } = formatContactsToArray(data.data);
          const userNames = [...emails, ...mobiles];

          const loginIdMatchList =
            [...isMobileUsed, ...isEmailUsed].filter(
              (item) => item.loginIdMatchFlag === 'Y',
            ) || [];

          const { insuredAccessFlag, selectContactFlag } = data.data;
          const shouldShowUsernameField = getShouldShowUsernameField(
            body.policyType,
            insuredAccessFlag,
            selectContactFlag,
          );
          if (shouldShowUsernameField) {
            await emmaSubmitFindPolicyGenOTP(
              {
                ...submitValues,
                loginId: data.data.loginId,
                checkHash: data.data.checkHash,
                autoLink: true,
                insuredAccessFlag: data.data.insuredAccessFlag,
                shouldShowUsernameField,
              },
              fromPage,
            )(dispatch, getState);
          } else if (loginIdMatchList.length > 0) {
            // find first loginIdMatchFlag Y
            const contactObj = loginIdMatchList[0];
            const contactType = contactObj.email ? 'email' : 'mobile';
            await emmaSubmitFindPolicyGenOTP({
              policyType: submitValues.policyType,
              checkHash: data.data.checkHash,
              contactType,
              contactIndex: String(contactObj.index),
              selectedLabel:
                contactType === 'email' ? contactObj.email : contactObj.mobile,
              countryCode:
                contactType === 'mobile' ? contactObj.countryCode : '',
              autoLink: true,
              insuredAccessFlag: data.data.insuredAccessFlag,
              shouldShowUsernameField,
            })(dispatch, getState);
          } else if (data.data.checkHash) {
            if (
              Object.keys(data.data.emails).length === 0 &&
              Object.keys(data.data.mobiles).length === 0
            ) {
              const errorCode = 'CUSEXP17';
              dispatch({
                type: EM_FINDMYPOLICY_FAIL,
                errorCode,
              });

              const errorConfig = getErrorConfig({
                apiCode: errorCode,
                featureCode: FEATURE_CODES.forgetUsername,
                policyTypeCode: POLICY_TYPE_CODES[submitValues.policyType],
              });

              dispatch(
                goTo(
                  `/${currLang}/${
                    config.webview.identityFEPath
                  }/emma/find-my-policy/${routeName}/policyfound-fail?errorCode=${
                    errorConfig.errorCode
                  }&fromPage=${encodeURIComponent(fromPage)}`,
                ),
              );
            } else {
              dispatch({
                type: EM_FINDMYPOLICY_NOT_MATCH,
                checkHash: data.data.checkHash,
                userNames,
                countryCodeMap: data.data.isMobileUsed,
                emailMap: data.data.isEmailUsed,
              });
              dispatch(
                goTo(
                  `/${currLang}/${config.webview.identityFEPath}/emma/find-my-policy/${routeName}/policy-not-match`,
                ),
              );
            }
          } else {
            dispatch({
              type: EM_FINDMYPOLICY_SUCCESS,
            });
            dispatch(
              goTo(
                `/${currLang}/${config.webview.identityFEPath}/emma/find-my-policy/${routeName}/policy-found`,
              ),
            );
          }
        } else {
          dispatch({
            type: EM_FINDMYPOLICY_SUCCESS,
          });
          dispatch(
            goTo(
              `/${currLang}/${config.webview.identityFEPath}/emma/find-my-policy/${routeName}/policy-found`,
            ),
          );
        }
      })
      .catch((error) => {
        dispatch({
          type: EM_FINDMYPOLICY_SERVER_REQ_COMPLETE,
        });

        let errorCode;
        if (error.response && error.response.data.response.reasonCode) {
          const { payload, reasonCode, reason } = error.response.data.response;
          errorCode = reasonCode;
          const userContact =
            payload && payload.userContact ? payload.userContact : '';
          dispatch({
            type: EM_FINDMYPOLICY_FAIL,
            errorCode,
            errorData: reason,
            errorValues: {
              userContact,
            },
          });
        } else {
          errorCode = 'CUSEXP';
          dispatch({
            type: EM_FINDMYPOLICY_FAIL,
            errorCode,
          });
        }

        const errorConfig = getErrorConfig({
          apiCode: errorCode,
          featureCode: FEATURE_CODES.forgetUsername,
          policyTypeCode: POLICY_TYPE_CODES[submitValues.policyType],
        });

        dispatch(
          goTo(
            `/${currLang}/${
              config.webview.identityFEPath
            }/emma/find-my-policy/${routeName}/policyfound-fail?errorCode=${
              errorConfig.errorCode
            }&fromPage=${encodeURIComponent(fromPage)}`,
          ),
        );
      });
  };
};

export const goToDeepLink = (link) => {
  return async (dispatch) => {
    dispatch(goTo(link));
  };
};

export const emmaSubmitFindPolicyByAxaCard = (submitValues, fromPage = '') => {
  return async (dispatch, getState) => {
    const currStateVal = getState();
    const currLang = currStateVal.language.lang;
    // const fmpObj = currStateVal.emmaFindMyPolicy;
    const formData = {
      axaId: getAxaIdByJwtToken(),
      locale: currLang || 'en',
      ...submitValues,
    };
    dispatch({
      type: EM_FINDMYPOLICY_SERVER_REQ_START,
    });
    const routeName = ROUTE_NAMES[submitValues.policyType];

    const queryStr = {
      featureName: 'findmypolicyEB',
    };

    const option = {
      headers: {
        apikey: config.muleApiKey,
      },
    };

    await muleSoftFetch(
      parseQueryString(
        `${config.webview.muleApiBaseUrl}/customers/registration`,
        queryStr,
      ),
      'post',
      { registrationRequest: formData },
      option,
    )
      .then(() => {
        dispatch({
          type: EM_FINDMYPOLICY_SERVER_REQ_COMPLETE,
        });
        dispatch({
          type: EM_FINDMYPOLICY_SUCCESS,
        });
        dispatch(
          goTo(
            `/${currLang}/${config.webview.identityFEPath}/emma/find-my-policy/${routeName}/policy-found`,
          ),
        );
      })
      .catch((error) => {
        dispatch({
          type: EM_FINDMYPOLICY_SERVER_REQ_COMPLETE,
        });
        let errorCode;
        if (error.response && error.response.data.response.reasonCode) {
          const { payload, reasonCode } = error.response.data.response;
          errorCode = reasonCode;
          const userContact =
            payload && payload.userContact ? payload.userContact : '';
          dispatch({
            type: EM_FINDMYPOLICY_FAIL,
            errorCode,
            errorData: payload,
            errorValues: {
              userContact,
            },
          });
        } else {
          errorCode = 'CUSEXP';
          dispatch({
            type: EM_FINDMYPOLICY_FAIL,
            errorCode,
          });
        }

        const errorConfig = getErrorConfig({
          apiCode: errorCode,
          featureCode: FEATURE_CODES.forgetUsername,
          policyTypeCode: POLICY_TYPE_CODES[submitValues.policyType],
        });

        dispatch(
          goTo(
            `/${currLang}/${
              config.webview.identityFEPath
            }/emma/find-my-policy/${routeName}/policyfound-fail?errorCode=${
              errorConfig.errorCode
            }&fromPage=${encodeURIComponent(fromPage)}`,
          ),
        );
      });
  };
};

export const emmaSubmitFindPolicyByOldCard = (submitValues, fromPage = '') => {
  return async (dispatch, getState) => {
    const currLang = getState().language.lang;
    const formData = {
      axaId: getAxaIdByJwtToken(),
      locale: currLang || 'en',
      ...submitValues,
    };
    dispatch({
      type: EM_FINDMYPOLICY_SERVER_REQ_START,
    });
    const routeName = ROUTE_NAMES[submitValues.policyType];

    const queryStr = {
      featureName: 'findmypolicyEB',
    };
    const option = {
      headers: {
        apikey: config.muleApiKey,
      },
    };
    await muleSoftFetch(
      parseQueryString(
        `${config.webview.muleApiBaseUrl}/customers/registration`,
        queryStr,
      ),
      'post',
      { registrationRequest: formData },
      option,
    )
      .then(() => {
        dispatch({
          type: EM_FINDMYPOLICY_SERVER_REQ_COMPLETE,
        });
        dispatch({
          type: EM_FINDMYPOLICY_SUCCESS,
        });
        dispatch(
          goTo(
            `/${currLang}/${config.webview.identityFEPath}/emma/find-my-policy/${routeName}/policy-found`,
          ),
        );
      })
      .catch((error) => {
        dispatch({
          type: EM_FINDMYPOLICY_SERVER_REQ_COMPLETE,
        });

        let errorCode;
        if (error.response && error.response.data.response.reasonCode) {
          errorCode = error.response.data.response.reasonCode;
          dispatch({
            type: EM_FINDMYPOLICY_FAIL,
            errorCode,
          });
        } else {
          errorCode = 'CUSEXP';
          dispatch({
            type: EM_FINDMYPOLICY_FAIL,
            errorCode,
          });
        }

        const errorConfig = getErrorConfig({
          apiCode: errorCode,
          featureCode: FEATURE_CODES.forgetUsername,
          policyTypeCode: POLICY_TYPE_CODES[submitValues.policyType],
        });

        dispatch(
          goTo(
            `/${currLang}/${
              config.webview.identityFEPath
            }/emma/find-my-policy/${routeName}/policyfound-fail?errorCode=${
              errorConfig.errorCode
            }&fromPage=${encodeURIComponent(fromPage)}`,
          ),
        );
      });
  };
};

export const fetchAgreementsStatus = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: EM_FINDMYPOLICY_AGREEMENTS_STATUS_FETCH_START,
      });
      const featureName = 'registration';
      const { data } = await muleSoftFetch(
        `${config.webview.muleXpApiBaseUrl}/agreements?featureName=${featureName}`,
        'get',
      );
      dispatch({
        type: EM_FINDMYPOLICY_AGREEMENTS_STATUS_FETCH_COMPLETE,
        payload: { agreementsStatus: data },
      });
      return data;
    } catch (error) {
      dispatch({
        type: EM_FINDMYPOLICY_AGREEMENTS_STATUS_FETCH_FAIL,
      });
      throw error;
    }
  };
};
